import SvgIcon from '@mui/material/SvgIcon';

const PackageIcon = (props) => (
  <SvgIcon {...props}>
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.18881 17.2024V11.4803L4.17674 8.57744V14.2996L9.18881 17.2024ZM10.8595 17.2024L15.8716 14.2996V8.57744L10.8595 11.4803V17.2024ZM9.18881 19.1237L3.34139 15.7614C3.07686 15.6083 2.87151 15.4064 2.72532 15.1558C2.57914 14.9052 2.50604 14.6267 2.50604 14.3204V7.67945C2.50604 7.37315 2.57914 7.0947 2.72532 6.8441C2.87151 6.5935 3.07686 6.39162 3.34139 6.23847L9.18881 2.8762C9.45334 2.72306 9.73179 2.64648 10.0242 2.64648C10.3165 2.64648 10.595 2.72306 10.8595 2.8762L16.7069 6.23847C16.9715 6.39162 17.1768 6.5935 17.323 6.8441C17.4692 7.0947 17.5423 7.37315 17.5423 7.67945V14.3204C17.5423 14.6267 17.4692 14.9052 17.323 15.1558C17.1768 15.4064 16.9715 15.6083 16.7069 15.7614L10.8595 19.1237C10.595 19.2768 10.3165 19.3534 10.0242 19.3534C9.73179 19.3534 9.45334 19.2768 9.18881 19.1237ZM13.3655 8.09712L14.9736 7.17824L10.0242 4.31718L8.39523 5.25694L13.3655 8.09712ZM10.0242 10.0393L11.6531 9.09953L6.70366 6.23847L5.07473 7.17824L10.0242 10.0393Z"
        fill="#497262"
      />
    </svg>
  </SvgIcon>
);

export default PackageIcon;
